// TODO: SV - See what is common and keep it here and get Dash to also use this (for now it is duplicated).

// externals
import type { Middleware } from 'redux';
import { applyMiddleware, createStore, compose } from 'redux';
import { setAutoFreeze } from 'immer';
import { connectRouter } from 'connected-react-router';

// utils
import historyInstance from './historyInstance';
import { reducerRegistry } from './reducerRegistry';
import { getWindowObj } from '../utils/windowUtil';
import { scopeMiddleware } from '@makemydeal/shared-scoped-store';
import type { ScopeCreationFactory } from '@makemydeal/shared-scoped-store';
// import { getModule } from '../utils/moduleUtil';

// selectors
// import * as featureTogglSelectors from '../selectors/featureToggleSelectors';
// import { dealerSelectors } from '@makemydeal/dr-shared-store';

// TODO: DASH - fix this
export interface IPreloadedState {}

// { router: connectRouter(history), ...reducers }

export function configureStore(
    preloadedState: IPreloadedState,
    initialMiddleware: Middleware<any, any, any>[],
    initialGlobalReducers: any,
    initialScopedReducers?: any,
    isScoped = false,
    scopeCreationFactory?: ScopeCreationFactory,
    telemetryMiddleware: Middleware<any, any, any>[] = []
) {
    reducerRegistry.reset();
    reducerRegistry.registerGlobal('router', connectRouter(historyInstance));
    reducerRegistry.registerMultipleGlobal(initialGlobalReducers);
    initialScopedReducers && reducerRegistry.registerMultipleScoped(initialScopedReducers);

    if (isScoped) {
        reducerRegistry.setScoped();
    }

    if (scopeCreationFactory) {
        reducerRegistry.setScopeCreationFactory(scopeCreationFactory);
    }

    const allReducers = reducerRegistry.getReducers();

    const windowObj = getWindowObj();

    const reduxDevTools = typeof windowObj === 'object' && (windowObj as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    // Telemetry middleware is appended AFTER all business middleware so it always
    // runs last in the applied chain (e.g. stateSnapshotTelemetryMiddleware
    // observes the true post-reducer state). Scope-wrapped identically to
    // business middleware when the store is scoped.
    const businessAndTelemetry = [...initialMiddleware, ...telemetryMiddleware];
    const middlewares = isScoped ? businessAndTelemetry.map((m) => scopeMiddleware(m)) : businessAndTelemetry;

    const composeEnhancers = reduxDevTools
        ? (windowObj as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'Dash', trace: true, maxAge: 150, traceLimit: 100 })
        : compose;
    const store = createStore(allReducers, preloadedState, composeEnhancers(applyMiddleware(...middlewares)));
    reducerRegistry.setChangeListener((reducers) => {
        store.replaceReducer(reducers);
    });
    /**
     * https://immerjs.github.io/immer/freezing
     *
     * Setting autofreeze to false for the dev store to avoid problems with redux devtools replaying actions
     * when replaceReducer is called
     */
    setAutoFreeze(false);

    return store;
}
